import uniq from 'lodash/uniq';
/**
 * [getProductRobotImages]
 * Returns an Array of IRobotAsset objects, for use in the PDP page
 *
 * We take the first X(cutoff amount) robot image urls returned and return to the PDP page
 *
 * @param   {Array} robotAssets   Array of robot image urls
 * @param   {number} cutOff returns the first x robots, defaulted to 3
 * @returns {Array}
 */
export const getProductRobotImages = ({ robotAssets = [], cutOff = 3 }) => {
  if (robotAssets.length === 0) return null;

  const robotList = uniq(robotAssets);

  return robotList.slice(0, cutOff);
};
